// extracted by mini-css-extract-plugin
export default {"wrapper":"UserItem_wrapper__TfNx5","title":"UserItem_title__1NNFA","value":"UserItem_value__Jgbjj","skeleton":"UserItem_skeleton__cdSzN","load":"UserItem_load__eo8Ua"};